"use client"

import { useNavigate } from "react-router-dom"
import {
  Container,
  Typography,
  Button,
  Box,
  AppBar,
  Toolbar,
  Avatar,
  IconButton,
  BottomNavigation,
  BottomNavigationAction,
} from "@mui/material"
import { Notifications as NotificationsIcon, AccountCircle as AccountCircleIcon } from "@mui/icons-material"
import { toast } from "react-toastify"
import CalendarTodayIcon from "@mui/icons-material/CalendarToday"
import HomeIcon from "@mui/icons-material/Home"
import PaymentIcon from "@mui/icons-material/Payment"
import ExitToAppIcon from "@mui/icons-material/ExitToApp"

const Politique = () => {
  const navigate = useNavigate()

  const handleAccept = () => {
    navigate("/home")
  }
  // Logout function
  const handleLogout = () => {
    localStorage.removeItem("CC_Token")
    localStorage.removeItem("user")
    toast.success("Vous avez été déconnecté avec succès.", {
      position: "top-right",
      autoClose: 3000,
    })
    setTimeout(() => navigate("/login"), 4000) // Redirect after toast
  }
  const handleRefuse = () => {
    localStorage.removeItem("CC_Token")
    localStorage.removeItem("user")
    navigate("/login")
  }
  const handleNavigateToNotifications = () => {
    navigate("/notifications") // Redirige vers la page notifications
  }
  const handleProfile = () => {
    navigate("/Profile")
  }
  return (
    <div>
      {/* AppBar/Header */}
      <AppBar position="fixed" sx={{ backgroundColor: "#003366" }}>
        <Toolbar>
          <Avatar alt="Logo" src={"../assets/cej.png"} sx={{ width: 40, height: 40, marginRight: "0.5rem" }} />
          <Typography
            variant="h6"
            sx={{
              flexGrow: 1,
              fontSize: { xs: "1rem", sm: "1.25rem" },
              color: "#ffffff",
            }}
          >
            Club Équestre Jafoura
          </Typography>
          <IconButton color="inherit" onClick={handleNavigateToNotifications}>
            <NotificationsIcon />
          </IconButton>
          <IconButton color="inherit" onClick={handleProfile}>
            <AccountCircleIcon />
          </IconButton>
          <IconButton color="inherit" onClick={handleLogout}>
            <ExitToAppIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      {/* Main Content */}
      <Container
        maxWidth="sm"
        sx={{
          marginTop: "100px",
          padding: "2rem",
          backgroundColor: "#f5f5f5",
          borderRadius: "8px",
        }}
      >
        <Typography variant="h4" sx={{ textAlign: "center", marginBottom: "1rem", color: "#003366" }}>
        Règlement intérieur
        </Typography>
        

        <Typography
          variant="h5"
          sx={{ textAlign: "center", marginTop: "2rem", marginBottom: "1rem", color: "#003366" }}
        >
          ASSOCIATION EQUESTRE JAFOURA
        </Typography>
        <Typography variant="h6" sx={{ textAlign: "center", marginBottom: "1.5rem", color: "#003366" }}>
          
        </Typography>

        <Typography variant="body1" sx={{ marginBottom: "1rem", textAlign: "justify" }}>
          <strong>Engagement :</strong>
          <br />
          Tout membre de l'association s'engage à respecter le présent règlement intérieur et à le faire respecter par
          ses éventuels accompagnateurs ou invités. Ce règlement intérieur est affiché. Une copie de ce règlement peut à
          tout moment et sur demande à la direction du club en être fournie aux membres de l'association. La direction
          du club peut à tout moment introduire des modifications à ce règlement intérieur sans avoir à en aviser
          préalablement les membres de l'association. Les tarifs de toutes les prestations proposées par le club sont
          affichés. Ces tarifs sont fixés par la direction du club et peut être modifiés à tout moment et sans préavis
          par elle. Sur demande, l'association fournira un reçu pour tout paiement de prestations effectué.
        </Typography>

        <Typography variant="body1" sx={{ marginBottom: "1rem", textAlign: "justify" }}>
          <strong>Carte membre :</strong>
          <br />
          Le paiement de droit annuel d'adhésion (carte membre) est exigé de tout cavalier et/ou propriétaire de
          chevaux. La carte de membre ouvre droit aux prestations suivantes : mise en pension de chevaux, utilisations
          des infrastructures techniques et sportives du club, cours d'équitation collectifs ou individuels, 10% de
          remise au club house (Restau-Café) et 10% de remise aux seins du magasin équestre du club. La carte membre est
          payable une fois par an. Sa validité court jusqu'à fin décembre de l'année en cours. La direction du club
          pourra à son entière discrétion et à tout moment décider d'exclure un membre de l'association. Un préavis de
          quinze jours sera dans ce cas signifié par courrier recommandé à la personne concernée. En aucune circonstance
          et pour quelque motif, il ne pourra être demandé à l'association le remboursement partiel ou complet de droit
          annuel d'adhésion payée.
        </Typography>

        <Typography variant="body1" sx={{ marginBottom: "1rem", textAlign: "justify" }}>
          <strong>Licence fédérale :</strong>
          <br />
          Il est recommandé à tous les cavaliers membre de l'association de souscrire à une licence auprès de la
          Fédération Tunisienne des Sports Equestres. Cette licence est obligatoire pour les cavaliers participant aux
          compétitions organisées sous l'égide la FTSE. Les droits de licence et les pièces du dossier de demande de
          licence sont collectés par l'association et transmis à la FTSE. Ces droits incluent une couverture
          d'assurance.
        </Typography>

        <Typography variant="body1" sx={{ marginBottom: "1rem", textAlign: "justify" }}>
          <strong>Accueil en pension de chevaux de propriétaires :</strong>
          <br />
          Le club offre aux propriétaires de chevaux la possibilité de les accueillir en pension. La pension inclut les
          prestations suivantes (liste limitative) : mise à disposition d'un box, nourriture du cheval, renouvellement
          régulier de la litière du box, mise à disposition d'un casier personnel dans l'écurie. La fourniture de toute
          prestation supplémentaire, si elle est acceptée par l'association, sera soumise au règlement d'une
          rémunération spécifique. Les frais suivants (liste non limitative) ne sont pas inclus dans la pension et sont
          à la charge du propriétaire : vermifuge, vaccination, frais de maréchal-ferrant, frais de vétérinaire. Ces
          frais pourront être, en cas de nécessité et sans engagés à l'initiative de l'association et devront dans ce
          cas lui être remboursés par le propriétaire. La pension payable trimestriellement et d'avance au plus tard le
          15 du mois courant.
        </Typography>

        <Typography variant="body1" sx={{ marginBottom: "1rem", textAlign: "justify" }}>
          A l'admission de son cheval au club, le propriétaire sera tenu fournir le carnet de vaccination de son cheval
          ainsi qu'une justificatif valable de la propriété du cheval (carte de propriétaire, contrat de vente...). Le
          cheval pourra également être soumis à une période de quarantaine dans un lieu prévu à cet effet. Dans le cas
          de chevaux à la copropriété, les copropriétaires sont tenus de désigner l'un d'eux comme seul vis-à-vis pour
          toutes les relations avec le club et notamment pour le paiement de la pension. Tous les copropriétaires
          restent néanmoins engagés solidairement vis-à-vis du club. A l'admission de son cheval au club, le
          propriétaire pourra se voir exiger le paiement d'une caution dont le montant sera établi à l'entière
          discrétion de la direction du club. Cette caution lui sera restituée au moment ou son cheval quittera le club,
          sous déduction des éventuelles sommes dues. Un propriétaire peut autoriser sous entière responsabilité que son
          cheval soit monté par une autre personne. Celle-ci doit toutefois s'être préalablement acquittée d'une carte
          de membre. Les propriétaires sont tenus d'assurer à leurs chevaux un minimum d'exercice physique quotidien.
          Ils peuvent demander en leur absence mais sous leur entière responsabilité, que le personnel du club lâche
          leurs chevaux en paddock. La direction du club pourra à son entière discrétion décider à tout moment de ne
          plus accepter de garder un cheval en pension. Un préavis de quinze jours sera dans ce cas signifié par
          courrier recommandé au propriétaire du cheval pour son enlèvement. Passé ce délai, le club sera autorisé à
          prendre toute mesure qu'il jugera adéquate pour faire enlever le cheval aux frais du propriétaire. En cas de
          retard dans le paiement de la pension ou le remboursement de frais engés par le club pour le compte du
          propriétaire, le club sera en droit, auprès sommation par lettre recommandée restée sans réponse pendant
          quinze jours, de prendre toute mesure qu'il jugera adéquate pour ne plus laisser au propriétaire la libre
          disposition de son cheval et de son matériel, pour éventuellement faire enlever le cheval aux frais du
          propriétaire et pour récupérer toutes les sommes qui lui seraient dues. Tout les frais de justice seront à la
          charge du propriétaire.
        </Typography>

        <Typography variant="body1" sx={{ marginBottom: "1rem", textAlign: "justify" }}>
          <strong>Cours collectifs d'équitation (reprise):</strong>
          <br />
          L'association emploie des moniteurs qui dispensent aux membres qui le souhaitent des cours d'équitation en
          utilisant les chevaux et la sellerie du club ou leurs propres chevaux et matériel. Ces cours sont donnés en
          groupe (reprise) et leurs horaires sont fixés par les moniteurs et affichés dans le tableau de l'écurie.
          Plusieurs forfaits de paiement des cours sont proposées : mensuel, trimestriel, annuel. Le forfait
          mensuel/trimestriel/annuel est invisible, il n'est valable que pour le mois/trimestre/année pour lequel il a
          été payé et ne peut être reporté sur un autre mois/trimestre/année ou faire l'objet de compensation d'aucune
          sorte s'il n'a pas été totalement consommé Le forfait est dispensés avec les chevaux de l'association ou des
          chevaux de propriétaires Les cours ou les élèves sont régulièrement inscrits sont dus en cas d'absence de
          l'élève.
        </Typography>

        <Typography variant="body1" sx={{ marginBottom: "1rem", textAlign: "justify" }}>
          <strong>Cours particuliers d'équitation :</strong>
          <br />
          Les moniteurs employés par l'association peuvent à la demande d'un membre de l'association lui dispenser des
          cours particuliers d'équitation. Le tarif de ces cours est fixé à 40 dinars la séance pour les abonnées de
          l'association et à 50 dinars la séance pour les passagers (non-adhérent). Des personnes autres que les
          moniteurs employés par l'écurie peuvent également donner des cours particuliers aux propriétaires qui le
          souhaiteraient et utiliser dans ce cadre les infrastructures de l'association. Ces coachs privés devront
          toutefois avoir été préalablement autorisés par écrit par la direction du club. Cette autorisation est
          accordée à l'entière discrétion de la direction du club et peut être retirée à tout moment par elle sans avoir
          à motiver ce retrait d'autorisation. Les horaires de ces cours particuliers devront être fixés en dehors des
          horaires des cours assurés par les moniteurs du club.
        </Typography>

        <Typography variant="body1" sx={{ marginBottom: "1rem", textAlign: "justify" }}>
          <strong>Nourriture et litières des chevaux en pension :</strong>
          <br />
          Les rations de nourriture sont établies par le responsable de l'écurie. Le type et la quantité de nourriture
          donnée au cheval sont établis en fonction de la morphologie, de l'âge, la race, la saison et du niveau
          d'activités du cheval. Elles tiennent également compte des disponibilités et conditions du marché de
          l'alimentation animale en Tunisie. Seuls les palefreniers sont autorisés à nourrir les chevaux et à renouveler
          la litière des boxes. Toute réclamation concernant la ration de nourriture ou la propreté de la litière d'un
          box doit être faite au responsable de l'écurie qui chargera d'y répondre.
        </Typography>

        <Typography variant="body1" sx={{ marginBottom: "1rem", textAlign: "justify" }}>
          <strong>Sellerie :</strong>
          <br />
          Des casiers de rangement sont mis à la disposition des propriétaires dans l'écurie. Les propriétaires sont
          invités à ranger tout leur matériel dans ces casiers et à les fermer à clef. Malgré la présence des caméras de
          surveillance, l'association ne peut être tenue pour responsable de tout matériel perdu ou volé.
        </Typography>

        <Typography variant="body1" sx={{ marginBottom: "1rem", textAlign: "justify" }}>
          <strong>Carrière de travail :</strong>
          <br />
          Trois carrières en sable sont mises à la disposition des propriétaires. Les propriétaires ne peuvent utiliser
          ces carrières pendant que des cours y sont donnés par les moniteurs de l'association La carrière principale
          est réservée aux concours hippiques organisés par le club. Son accès est strictement interdit sans
          l'autorisation des moniteurs du club (le ramassage des crottins est nécessaire et obligatoire après chaque
          séance d'entrainement).
        </Typography>

        <Typography variant="body1" sx={{ marginBottom: "1rem", textAlign: "justify" }}>
          <strong>Paddocks:</strong>
          <br />
          Dans la mesure du possible, un paddock sera mis à la disposition des propriétaires pour y lâcher leurs chevaux
          en liberté. La mise en liberté d'un cheval doit obligatoirement s'effectuer sous la surveillance rapprochée de
          son propriétaire pour éviter tout risque d'accident.
        </Typography>

        <Typography variant="body1" sx={{ marginBottom: "1rem", textAlign: "justify" }}>
          <strong>Saut d'obstacles :</strong>
          <br />
          Des obstacles d'entrainements sont mis à la disposition des propriétaires. Pour leur sécurité, il est vivement
          recommandé de ne sauter qu'en présence d'un moniteur ou d'un coach privé. Les obstacles utilisés doivent être
          remis dans leur zone de stockage dès la fin de leur utilisation, afin de ne pas gêner les autres cavaliers.
        </Typography>

        <Typography variant="body1" sx={{ marginBottom: "1rem", textAlign: "justify" }}>
          <strong>Personnel du club :</strong>
          <br />
          Le personnel du club est au service des membres du club et s'efforcera de répondre à toutes leurs demandes
          raisonnables. En contrepartie, un total respect lui est du. Seul le responsable de l'écurie est habilité à
          donner des instructions de travail au personnel et tout différend éventuel avec l'un des membres du personnel
          doit être immédiatement signalé au responsable de l'écurie qui se changera de le régler.
        </Typography>

        <Typography variant="body1" sx={{ marginBottom: "1rem", textAlign: "justify" }}>
          <strong>Horaire de travail :</strong>
          <br />
          Les horaires de travail du personnel du club sont fixés par le responsable de l'écurie. En dehors de ces
          horaires, les propriétaires qui souhaitent pouvoir accéder à l'écurie et utiliser les infrastructures du club
          doivent en faire la demande préalable au responsable de l'écurie. Lundi (jour de repos du club), chaque
          propriétaire il a le droit de visiter son cheval et lui mettre en liberté au paddock ou lui faire travailler
          en liberté au rond du longe mais il est strictement interdit de monter à cheval.
        </Typography>

        <Typography variant="body1" sx={{ marginBottom: "1rem", textAlign: "justify" }}>
          <strong>Tenue des cavaliers :</strong>
          <br />
          Pour des raisons de sécurité et d'esthétique, la tenue de tous les cavaliers doit être correcte et adaptée à
          la pratique de l'équitation. Le port d'un casque de sécurité est obligatoire et toute personne qui monterait
          sans ce casque, le ferait sous son entière responsabilité.
        </Typography>

        <Typography variant="body1" sx={{ marginBottom: "1rem", textAlign: "justify" }}>
          <strong>Sécurité générale :</strong>
          <br />
          Les réactions parfois imprévisibles des chevaux ainsi que la présence de nombreux enfants parmi les membres du
          club, doit inciter chacun à redoubler de précautions pour écarter tout risque d'accident.
        </Typography>

        <Typography variant="body1" sx={{ marginBottom: "1rem", textAlign: "justify" }}>
          <strong>Propreté générale :</strong>
          <br />
          Le personnel déploie d'importants efforts pour maintenir l'enceinte du club dans le meilleur état de propreté.
          Tous les membres du club sont invités à leur faciliter cette tache en utilisant les rangements, poubelles et
          autres aménagements prévus à cet effet. Les crottins et le fumier doivent être déposés dans les lieux prévus à
          cet effet.
        </Typography>

        <Typography variant="body1" sx={{ marginBottom: "1rem", textAlign: "justify" }}>
          <strong>Parking :</strong>
          <br />
          Les voitures sont stationnées dans le parking du club sous l'entière responsabilité de leurs propriétaires.
        </Typography>

        <Typography variant="body1" sx={{ marginBottom: "1rem", textAlign: "justify" }}>
          <strong>Club House :</strong>
          <br />
          L'accès au club house (restau/café) est ouvert aux membres du club, à leurs parents et amis ainsi qu'aux non
          membres des clubs autorisés à cet effet. L'entendue et les tarifs de prestations du club house, ses horaires
          d'ouvertures ainsi que ses règles de fonctionnement sont fixées en toute discrétion par son gérant. Les
          membres du club comme les non membres sont tenus au strict respect de ces règles. Les adhérents des clubs
          peuvent profiter de 10% de remise à chaque consommation au club house (hors les jours du concours hippique)
        </Typography>

        <Typography variant="body1" sx={{ marginBottom: "1rem", textAlign: "justify" }}>
          <strong>Contact :</strong>
          <br />
          Responsable de l'écurie M. Dammak Ayoub – Tél : 25 900 901 Responsable du club house et aire des jeux M. Zekri
          Rami – Tél : 29 419 102
        </Typography>
<br></br><br></br>

      </Container>
      {/* Footer */}
      <Box sx={{ position: "fixed", bottom: 0, width: "100%", zIndex: 10 }}>
        <BottomNavigation sx={{ backgroundColor: "#003366" }}>
          <BottomNavigationAction
            label="Calendrier"
            icon={<CalendarTodayIcon sx={{ fontSize: 30, color: "#ffffff" }} />}
            onClick={() => navigate("/emploi")}
          />
          <BottomNavigationAction
            label="Home"
            icon={<HomeIcon sx={{ fontSize: 30, color: "#ffffff" }} />}
            onClick={() => navigate("/home")}
          />
          <BottomNavigationAction
            label="Paiement"
            icon={<PaymentIcon sx={{ fontSize: 30, color: "#ffffff" }} />}
            onClick={() => navigate("/payment")}
          />
        </BottomNavigation>
      </Box>
    </div>
  )
}

export default Politique
